import { createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  root: {
    flex: 1,
    position: "relative",
    "& iframe": {
      height: "100%",
      width: "100%",
      border: "none",
    },
  },
  centered: {
    width: "100%",
    marginTop: "2.5rem",
    paddingBottom: "4rem",
    textAlign: "center",
  },
});
